export default "__VITE_ASSET__DkSNCwoE__"